<template>
  <v-container id="dashboard" fluid tag="section">
<!--    <bread-crumbs :items="breadCrumbs" />-->

  </v-container>
</template>

<script>
export default {
  name: "Dashboard",

  data() {
    return {
      breadCrumbs: [
        {
          text: "داشبورد ",
          disabled: false,
          //to: { name: "" },
          exact: true,
        },
        {
          text: "",
          disabled: true,
          exact: true,
        },
      ],
    };
  },

  methods: {

  },
  async mounted() {

  },
  computed: {
    // paymentHistoryScope: {
    //   get() {
    //     return this.$store.getters["dashboard/getPaymentHistoryScope"];
    //   },
    //   set(value) {},
    // },

  },
  watch: {

  },
  beforeDestroy() {
    //this.resetState();
  },
  components: {},
};
</script>
<style >
.body-3,
.text-h3 {
  padding-right: 10px;
}
.v-application .grey--text,
.text-caption {
  color: black !important;
}
.v-application .text-caption {
  font-size: 13px !important;
  font-weight: bold !important;
}
</style>
